import { render, staticRenderFns } from "./activateCompare.vue?vue&type=template&id=70438508&scoped=true&"
import script from "./activateCompare.vue?vue&type=script&lang=js&"
export * from "./activateCompare.vue?vue&type=script&lang=js&"
import style0 from "./activateCompare.vue?vue&type=style&index=0&id=70438508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70438508",
  null
  
)

export default component.exports